module.exports = __webpack_public_path__ + "static/media/rooster.fb9032d8.svg";